@if (Pills.length > 0) {
    <div class="ra-activepills" role="list" aria-label="Active filters">
        @for (pill of Pills; track pill.Key) {
            <span class="ra-apill" role="listitem">
                {{ pill.Label }}: {{ pill.Value }}@if (pill.FromQuery) {<span class="ra-apill-origin"> · from your search</span>}
                <button type="button" (click)="Remove.emit(pill.Key)" [attr.aria-label]="'Remove ' + pill.Label + ': ' + pill.Value + ' filter'">✕</button>
            </span>
        }
    </div>
}
